import { Routes } from '@angular/router';
import { environment } from '@env/environment';
import { commonEnumsResolver } from '@infrastructure/resolvers';
import { authenticationGuard } from '@shared/guards/authentication.guard';
import { ShellComponent } from '@shared/layout/shell/shell.component';

export const routes: Routes = [
  // Conditional root redirect based on SSO configuration
  {
    path: '',
    pathMatch: 'full',
    redirectTo: environment.enableSSOCallback ? '/dashboard' : '/login',
  },
  // Only load auth routes if SSO is disabled
  ...(environment.enableSSOCallback
    ? []
    : [
        {
          path: '',
          loadChildren: () =>
            import('@features/auth/auth.routes').then(m => m.AUTH_ROUTES),
        },
      ]),
  {
    path: 'dashboard',
    component: ShellComponent,
    canActivate: [authenticationGuard],
    resolve: { enums: commonEnumsResolver },
    loadChildren: () =>
      import('@features/dashboard/dashboard.routes').then(
        m => m.DASHBOARD_ROUTES
      ),
  },
  {
    path: 'access-denied',
    loadChildren: () =>
      import('@app/shared/error-pages/access-denied/access-denied.routes').then(
        m => m.ACCESS_DENIED_ROUTES
      ),
  },
  {
    path: 'internal-server-error',
    loadChildren: () =>
      import('@app/shared/error-pages/internal-server-error/internal-server-error.routes').then(
        m => m.INTERNAL_SERVER_ERROR_ROUTES
      ),
  },
  {
    path: '**',
    loadChildren: () =>
      import('@app/shared/error-pages/not-found/not-found.routes').then(
        m => m.NOT_FOUND_ROUTES
      ),
  },
];
